<template>
	<nav class="drop-panel ns" :class="extraClasses" @pointerdown="stopEvent">
		<div class="drop-panel-body" :class="bodyClass">
			<slot></slot>
		</div>
	</nav>
</template>

<script setup lang="ts">
import {ref, computed} from "vue";

const props = withDefaults(defineProps<{
	appearance?: "menu" | "dropdown"
	bodyClass?: any
}>(), {
	appearance: "menu"
});

const extraClasses = computed<string[]>(() => {
	const cls:string[] = [];
	cls.push("drop-panel-" + props.appearance);
	return cls;
});

/**
 * Stop event bubbling to prevent root element loosing focus
 */
function stopEvent(e:PointerEvent) {
	//console.log("drop-panel.pointerdown");
	e.stopPropagation();
	e.preventDefault();
}
</script>

<style>
.drop-panel {
	display: flex;
	flex-direction: column;
	box-sizing: border-box;
	background-color: var(--bg);
	color: var(--fg);
	border: 1px solid var(--border-color);
	max-height: 100vh;
	border-radius: var(--radius);
	user-select: none;
	-webkit-user-select: none;
	z-index: var(--drop-z-index);

	& > .drop-panel-body {
		border-radius: calc(var(--radius) - 1px);
		overflow-x: hidden;
		overflow-y: auto;
		scrollbar-width: none;
		background-color: transparent;
		box-sizing: border-box;
	}
}

/** Appearances **/
.drop-panel-menu,
.drop-panel-dropdown {
	--radius: var(--menu-radius);
	box-shadow: var(--panel-shadow);
}
</style>